import {AppState} from '@store';
import {createSelector} from '@ngrx/store';
import {getSelectors} from '@ngrx/router-store';

/**
 * Get State value.
 * @param {AppState} state
 */
const getState = (state: AppState) => state.router;

/** Auxiliary '{selectRouteParams, selectRouteParam, selectQueryParam, selectQueryParams, selectUrl}' variable.' */
const {selectRouteParams, selectRouteParam, selectQueryParam, selectQueryParams, selectUrl} = getSelectors(getState);
/**
 * Create a selector for the Page of the MasterContentState.
 */
const getPage = createSelector(selectUrl, (url: string) => url?.substr(1));

/**
 * Auxiliary constant declaration with selectors for  page.
 */
export const routerSelectors = {
	router: {
		routeParam: selectRouteParam,
		routeParams: selectRouteParams,
		queryParam: selectQueryParam,
		queryParams: selectQueryParams,
		url: selectUrl,
	},
	page: getPage,
};
